import {mapWritableState} from "pinia";
import {useLoginStore} from "@/stores/LoginStore";
import Constants from "@/assets/js/constants";

export default {

    computed: {

        ...mapWritableState(useLoginStore, {
            loginMode: 'loginMode',
        }),

        isLocalMode() {
            return this.loginMode === 'local'
        },

        isFtpMode() {
            return this.loginMode === Constants.login.ftpOnly
        },

        isSupportMode() {
            return this.loginMode === 'support'
        }

    }

}
